export default __webpack_public_path__ + "static/media/car.6c39c5e7.svg";